module.exports = __webpack_public_path__ + "static/collectorcans-slide-img-4-de-DE-99adbe57a986e80b18d4776e3e41544e.png";